import React from 'react';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import {Icon} from 'epic-diesel-common';
import {FormsyProps} from '../external/types';

//@ts-ignore
import styles from './Checkbox.pcss';

interface Props extends FormsyProps {
    name: string;
    className?: string;
    onChange?: (name: string, value: boolean) => void;
}

const CheckBox: React.FC<Props> = props => {
    const {name, children, className, getValue, isPristine, showError, getErrorMessage} = props;

    const onClick = event => {
        if (props.onChange) {
            const value = !props.getValue();
            props.onChange(props.name, value);
        }
    };

    const isError = !isPristine() && showError();
    const wrapperClasses = cx(styles.wrapper, className);
    const isChecked = !!getValue();

    return (
        //@ts-ignore
        <div className={wrapperClasses} name={name} onClick={onClick}>
            <div className={styles.checkboxContainer}>
                <Icon
                    className={styles.icon}
                    icon={isChecked ? 'CHECKED' : 'UNCHECKED'}
                    fontSize="small"
                />
                <div className={styles.text}>{children}</div>
            </div>
            {isError && <div className={styles.error}>{getErrorMessage()}</div>}
        </div>
    );
};

export default withFormsy(CheckBox);
